
<ng-container *ngIf="model?.Amazon">
<div class="card">
  <div class="card-body up">
    <div class="cont_info">
      <div class="info" *ngIf="modelRemuneration && showRemuneration">
        <img src="../../../assets/images/amazon-giftcard.svg" class="logo-card" alt="Tarjeta Regalo Amazon">
        <div class="info-text mb-1">La remuneración está ligada al nivel de la concesión en el ranking de Calidad al
          cierre
          del Cuatrimestre.</div>
        <div class="info-text mb-1" *ngIf="modelRemuneration.Position != null">Actualmente su Concesión está en el
          nivel:
          {{modelRemuneration.Position}}</div>
        <div class="info-text mb-1" *ngIf="modelRemuneration.Position == null">Actualmente su Concesión no tiene nivel
          asignado</div>
      </div>
      <h5 class="title-card">{{model.Title}}</h5>
      <div class="info-text range-date"><strong>Desde</strong> {{model.StartDate | date:'dd-MM-yyyy'}} / <strong>Hasta</strong>
        {{model.EndDate | date:'dd-MM-yyyy'}}</div>
    </div>

    <div class="logo">
      <img src="../../../assets/images/amazon-simplylogo.svg" class="amazon-simply" alt="Amazon">
    </div>

  </div>
  <div class="card-body" *ngIf="totalRemuneration > 0">
    <div class="cont_amount">
      <div class="info-text">Saldo Actual</div>
      <div class="total-amount">{{totalRemuneration | currency:'EUR'}}</div>
    </div>
  </div>
  <div class="card-footer">
    <img src="../../../assets/images/rg-logo-white.svg" class="logo-rg" alt="Renault Group">
    <div class="info-text" *ngIf="model.IsOpen"><strong>Estado:</strong> En curso</div>
    <div class="info-text" *ngIf="!model.IsOpen"><strong>Estado:</strong> Finalizado</div>
  </div>
</div>
</ng-container>

<ng-container *ngIf="!model?.Amazon">
<div class="card amount-card">
  <div *ngIf="modelRemuneration && showRemuneration" class="card-body">
    <span class="card-title">La remuneración está ligada al nivel de la concesión en el ranking de Calidad al cierre del
      Cuatrimestre.</span>
    <span *ngIf="modelRemuneration.Position != null" class="card-title">Actualmente su Concesión está en el nivel:
      {{modelRemuneration.Position}}</span>
    <span *ngIf="modelRemuneration.Position == null" class="card-title">Actualmente su Concesión no tiene nivel
      asignado</span>
  </div>
  <div class="card-body">
    <h5 class="card-title">{{model.Title}}</h5>    
    <div class="range-date"><strong>Desde</strong> {{model.StartDate | date:'dd-MM-yyyy'}} / <strong>Hasta</strong>
      {{model.EndDate | date:'dd-MM-yyyy'}}</div>
  </div>

  <div class="card-footer bg-transparent">
    <div class="cont-amount" *ngIf="totalRemuneration > 0">
      <div class="text">Remuneración:</div>
      <div class="logo-amount">
        <div class="logo-card"><img src="../../../assets/images/rg-logo-white.svg" alt="Renault Group"></div>
        <div class="amount">{{totalRemuneration | currency:'EUR'}}</div>
      </div>
    </div>
    <div class="cont-footer">
      <p class="card-text" *ngIf="model.IsOpen"><strong>Estado:</strong> En curso</p>
      <p class="card-text" *ngIf="!model.IsOpen"><strong>Estado:</strong> Finalizado</p>
    </div>
  </div>
</div> 

</ng-container>




